import { createStyles, withStyles } from '@material-ui/core';
import { border, transition } from '@topconagriculture/theme';
import classNames from 'classnames';
import * as React from 'react';
import { FontIcon } from '../FontIcon';
import { TitleTooltip } from '../Tooltip';
const styles = (theme) => createStyles({
    root: {
        backgroundColor: 'transparent',
        color: theme.color.font.dark,
        width: 'auto',
        padding: '0.25em',
        cursor: 'default',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        flexDirection: 'column',
        position: 'relative',
    },
    disabled: {
        color: `${theme.color.grey.light} !important`,
        cursor: 'default !important',
    },
    horizontal: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        '& $label': {
            textAlign: 'left',
        },
    },
    spacedIcon: {
        margin: '0 0.5em',
        lineHeight: 0.6,
        order: 2,
    },
    badgeContainer: {
        display: 'inline-block',
        position: 'relative',
        width: 'auto',
        height: 'auto',
        lineHeight: 1,
    },
    badge: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'center',
        position: 'absolute',
        minWidth: '2.15em',
        minHeight: '1em',
        padding: '0.35em',
        top: 0,
        right: 0,
        borderRadius: '100%',
        marginTop: '-0.75em',
        marginRight: '-0.95em',
        fontSize: '0.6em',
        backgroundColor: theme.color.background.dark,
        color: theme.color.font.light,
        border: border('white', 2),
        transition: transition(150, 'opacity'),
        lineHeight: theme.font.lineHeight.mediumSmall,
        fontWeight: theme.font.weight.bold,
    },
    label: {
        lineHeight: 1.2,
        fontSize: theme.font.size.mediumSmall,
        textAlign: 'center',
        order: 1,
    },
    active: {
        cursor: 'pointer',
    },
});
const ActionIcon = (props) => {
    const { label, classes, iconName, iconColor, iconSize, labelSize = 16, className: classNameProp, labelClassName, horizontal = false, reversed, title, color, fromMui, contrastColor, badge, onClick, disabled, testId = `ActionIcon-${iconName}`, ...other } = props;
    const handleClick = disabled ? null : onClick;
    const rootClass = classNames(classes.root, classNameProp, horizontal ? classes.horizontal : null, onClick ? classes.active : null, disabled ? classes.disabled : null);
    const iconEl = iconName && (React.createElement(FontIcon, { "data-testid": `${testId}-icon`, iconName: iconName, disabled: disabled, color: iconColor || color || 'black', size: iconSize || 22, fromMui: fromMui }));
    const labelEl = label && (React.createElement("div", { "data-testid": `${testId}-label`, className: classNames(classes.label, labelClassName, disabled ? classes.disabled : null), style: { color, fontSize: labelSize, order: reversed ? 1 : 2 } }, label));
    const badgeStyle = {
        background: iconColor || color,
        borderColor: contrastColor,
        color: contrastColor,
        opacity: typeof badge !== 'undefined' && badge !== null && badge !== '' ? 1 : 0,
    };
    const badgeEl = (React.createElement("div", { "data-testid": `${testId}-badge`, className: classes.badge, style: badgeStyle }, badge));
    const actionIcon = badgeEl && !disabled ? (React.createElement("div", Object.assign({ className: rootClass, onClick: handleClick, "data-testid": testId }, other),
        React.createElement("div", { className: classNames(classes.badgeContainer, horizontal && classes.spacedIcon), style: { order: reversed ? 2 : 1 } },
            iconEl,
            badgeEl),
        labelEl)) : (React.createElement("div", Object.assign({ className: rootClass, onClick: handleClick, "data-testid": testId }, other),
        iconEl,
        " ",
        labelEl));
    if (title) {
        return (React.createElement(TitleTooltip, { title: title, "data-testid": `${testId}-tooltip}` }, actionIcon));
    }
    else {
        return actionIcon;
    }
};
export default withStyles(styles)(ActionIcon);
//# sourceMappingURL=ActionIcon.js.map